import React from "react";
import {ProjectList} from "../ProjectList";
import {LangItem} from "../../core/Helpers/LangItem";

export class RecentProjects extends React.Component {
    render() {
        return (
            <div className="recent-projects">
                <div className="recent-title">
                    <LangItem for={'Recent projects'} />
                </div>
                <div className="recent-wrap">
                    <ProjectList url={'get_all_projects'} page={'project'} />
                </div>
            </div>
        );
    }
}
